import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { ReactComponent as LogoIcon } from "../../Asset/pages.svg";
import "./eagle.css";

const data = [
  {
    id: 1,
    title: "Expanding Our Services to Meet Diverse Needs",
    subtitle: "BREATH",
    description:
      "Our comprehensive suite of tools spans chartering, vessels, and beyond, empowering clients to make informed decisions and enabling smarter, cleaner global trade.",
    image:
      "https://res.cloudinary.com/du44pwjoi/image/upload/v1736775080/a-person-holding-up-a-transparent-globe-with-dots-2023-11-27-05-16-50-utc_1_yrjuyj.png",
  },
  {
    id: 2,
    title: "Extending Our Global Support Network",
    subtitle: "REACH",
    description:
      "With a presence in key maritime hubs worldwide, we provide unparalleled support to clients, ensuring seamless operations across the globe.",
    image:
      "https://res.cloudinary.com/du44pwjoi/image/upload/v1736775081/tired-seaman-ab-or-bosun-on-deck-of-vessel-or-ship-2023-11-27-05-27-53-utc_1_qyq2cr.png",
  },
  {
    id: 3,
    title: "Deepening Insights into Client Needs",
    subtitle: "UNDERSTANDING",
    description:
      "We prioritize understanding the unique challenges of our clients, offering tailored solutions that address specific requirements in the dynamic maritime landscape.",
    image:
      "https://res.cloudinary.com/du44pwjoi/image/upload/v1736775081/lng-liquified-natural-gas-tanker-anchored-in-gas-2024-12-08-00-49-24-utc_1_ky72mh.png",
  },
  {
    id: 4,
    title: "Empowering Talent to Drive Innovation",
    subtitle: "PEOPLE",
    description:
      "Our team comprises industry experts dedicated to delivering excellence, and continuously enhancing our platform to meet evolving market demands.",
    image:
      "https://res.cloudinary.com/du44pwjoi/image/upload/v1736775081/aerial-view-oil-terminal-industrial-facility-stora-2025-01-08-10-36-10-utc_1_cmo2a6.png",
  },
  {
    id: 5,
    title: "Maintaining Integrity in Maritime Intelligence",
    subtitle: "TRUST",
    description:
      "We uphold the highest standards of accuracy and reliability, ensuring our clients can trust the data and insights our platform provides",
    image:
      "https://res.cloudinary.com/du44pwjoi/image/upload/v1736775080/paper-boats-on-light-blue-surface-on-white-backgro-2024-11-17-06-54-26-utc_1_rkkbzq.png",
  },
  {
    id: 6,
    title: "Continuously Enhancing Platform Performance",
    subtitle: "GROWTH",
    description:
      "We are committed to the ongoing development of our services, driving innovation to improve user experience and operational efficiency.",
    image:
      "https://res.cloudinary.com/du44pwjoi/image/upload/v1736775081/oil-refinery-plant-at-sunset-gas-chemical-equipme-2024-12-08-01-01-18-utc_1_znezyy.png",
  },
];

const Eagle = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <div className="eagle">
      <div className="header">
        <div className="wrapper">
        <div className="box">
          <p>Our Strategy</p>
          <h3>Driving Value Across Maritime Stakeholders</h3>
        </div>
        <div className="box">
          <p>
            We are dedicated to creating long-term sustainable value for all our
            stakeholders by building on our strong performance and maintaining
            our position as a leader in maritime digital solutions
          </p>
        </div>
          <LogoIcon />
        </div>
      </div>

      <div className="line"></div>

      <div className="marquee-wrapper">
        <div className="marquee">
          <div className="marquee__inner">
            <span>Scroll to Discover</span>
            <span className="dot">•</span>
            <span>Scroll to Discover</span>
            <span className="dot">•</span>
            <span>Scroll to Explore</span>

            {/* Duplicate to ensure seamless transition */}
            <span>Scroll to Discover</span>
            <span className="dot">•</span>
            <span>Scroll to Discover</span>
            <span className="dot">•</span>
            <span>Scroll to Explore</span>
          </div>
        </div>
        <div className="img"></div>
      </div>

      <div className="container">
        <div className="content-container">
          {data.map((item) => (
            <div key={item.id} className="card">
              <div className="image-container" data-aos="zoom-in">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="section">
                <h4>{item.subtitle}</h4>
                <h2>{item.title}</h2>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="empower">
        <div className="header">
          <div className="box-1">
            <p>Our Technology</p>
            <h3>Our Technology: Empowering Maritime Efficiency</h3>
          </div>
          <div className="box-2">
            <p>
              Vatug Technologies Limited takes technology as the heart of our
              mission to revolutionise vessel chartering and sales. We invest in
              cutting-edge digital solutions to provide our clients with
              unparalleled market insights and operational efficiency.
            </p>
          </div>
        </div>
      </div>

      <div class="container-down">
        <div class="card">
          <div>
            <span>Innovative Digital Solutions</span>
            <h2>Leveraging Data to Inform Stronger Decisions</h2>
            <p>
              Our platform utilizes advanced data analytics to offer real-time
              market intelligence, enabling users to make informed decisions
              with speed and accuracy. By integrating comprehensive data sets,
              we provide next-level insights that differentiate us from
              competitors.
            </p>
          </div>
          <div class="image-container" data-aos="zoom-in">
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736805619/above-the-clouds-2023-11-27-05-10-57-utc_1_r1r1eb.png"
              alt="4"
            />
          </div>
        </div>

        <div class="card">
          <div class="image-container" data-aos="zoom-in">
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736805622/vessel-crew-preparing-vessel-for-static-tow-tanker-2023-11-27-04-53-51-utc_1_k8gipf.png"
              alt="4"
            />
          </div>
          <div>
            <span>Seamless User Experience</span>
            <h2>Streamlined Workflows for Enhanced Productivity</h2>
            <p>
              We prioritize user-centric design, ensuring our tools are
              intuitive and seamlessly integrate into your existing workflows.
              Our digital solutions are developed in collaboration with industry
              professionals to address real-world challenges and enhance
              productivity.
            </p>
          </div>
        </div>

        <div class="card">
          <div>
            <span>Commitment to Innovation</span>
            <h2>Continuous Development for Future-Ready Solutions</h2>
            <p>
              We foster a culture of innovation, continually refining our
              digital strategy to deliver greater value to our clients. Our
              dedicated digital transformation team works tirelessly to develop
              data-driven solutions that keep you ahead in a dynamic maritime
              landscape.
            </p>
          </div>
          <div class="image-container" data-aos="zoom-in">
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736805618/aerial-view-of-oil-tankers-in-port-2025-01-09-12-25-41-utc_1_k67hxr.png"
              alt="4"
            />
          </div>
        </div>

        <div class="card">
          <div class="image-container" data-aos="zoom-in">
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736805618/oil-refinery-plant-at-sunset-gas-chemical-equipme-2024-12-08-01-01-18-utc_2_rjiyjt.png"
              alt="4"
            />
          </div>
          <div>
            <span>Global Connectivity</span>
            <h2>Connecting Stakeholders Across the Maritime Industry</h2>
            <p>
              Our platform serves as an intelligent marketplace, connecting
              charterers, shipowners, and brokers worldwide. By facilitating
              efficient and transparent transactions, we empower better
              decision-making and foster stronger industry relationships.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Eagle;
